import { computed } from 'vue'
import { useQuery } from 'vue-query'
import { useEvent } from '~/composables/api/useEvent'
import { useContext } from '~/composables/useContext'
import { useSentry } from '~/composables/useSentry'

export const useEventFeatures = (primaryEvent = false) => {
  const { getFeatures } = useEvent()
  const { eventId } = useContext()
  const { captureException } = useSentry()

  const { data: features, isFetched } = useQuery({
    queryKey: computed(() => ['eventFeatures', primaryEvent ? 'primary' : eventId.value]),
    queryFn: async () => {
      try {
        return await getFeatures(primaryEvent)
      }
      catch (e) {
        console.error(e)
        captureException(e)
        return null
      }
    },
  })

  return {
    features,
    isFetched,
    teamChanges: computed(() => features.value?.teamChanges ?? false),
    scoreboard: computed(() => features.value?.scoreboard ?? false),
    raffle: computed(() => features.value?.raffle ?? false),
    auction: computed(() => features.value?.auction ?? false),
  }
}
